import { createSlice } from '@reduxjs/toolkit';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  chosenDistributorID: '',
  chosenDistributorName: '',
  chosenConsignmentSKUOrderID: [], // obj id
  chosenConsignmentSKUOrderSerial: [],
  notes: '',
  listProducts: [],
  salesPDF: []
}

const slice = createSlice({
  name: 'consignmentReport',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    setChosenDistributorID(state, action) {
      state.isLoading = false;
      state.chosenDistributorID = action.payload
    },

    setChosenDistributorName(state, action) {
      state.isLoading = false;
      state.chosenDistributorName = action.payload
    },

    setChosenConsignmentSKUOrderID(state, action) {
      state.isLoading = false;
      state.chosenConsignmentSKUOrderID = action.payload
    },

    setChosenConsignmentSKUOrderSerial(state, action) {
      state.isLoading = false;
      state.chosenConsignmentSKUOrderSerial = action.payload
    },

    setNotes(state, action) {
      state.isLoading = false;
      state.notes = action.payload
    },

    setListProducts(state, action) {
      state.isLoading = false;
      state.listProducts = action.payload
    },

    setSalesPDF(state, action) {
      state.isLoading = false;
      state.salesPDF = action.payload
    },

    setBackFromProduct(state, action) {
      state.isLoading = false;
      state.backFromProduct = action.payload
    },

    resetConsignmentReport(state) {
      state.chosenDistributorID = ''
      state.chosenDistributorName = ''
      state.chosenConsignmentSKUOrderID = []
      state.chosenConsignmentSKUOrderSerial = []
      state.notes = ''
      state.listProducts = []
      state.salesPDF = []
    }

  }
})

// Reducer
export default slice.reducer;

// Actions
export const {
} = slice.actions;


// ----------------------------------------------------------------------
export function setChosenDistributorID(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setChosenDistributorID(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function setChosenDistributorName(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setChosenDistributorName(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function setChosenConsignmentSKUOrderID(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setChosenConsignmentSKUOrderID(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function setChosenConsignmentSKUOrderSerial(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setChosenConsignmentSKUOrderSerial(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function setNotes(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setNotes(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function setListProducts(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setListProducts(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function setSalesPDF(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setSalesPDF(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function setBackFromProduct(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setBackFromProduct(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function resetConsignmentReport() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.resetConsignmentReport())
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}